import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { getToken, setToken, clearToken } from "@/lib/authStorage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Handle Emergent Google OAuth return: {redirect}#session_id=... — process FIRST, before /auth/me.
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.slice(1)).get("session_id");
      // strip the fragment immediately so the session_id is used once and not re-processed
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      if (sid) {
        api.post("/auth/google-session", { session_id: sid })
          .then((r) => { setToken(r.data.token); setUser(r.data.user); })
          .catch(() => { setUser(false); })
          .finally(() => setLoading(false));
        return;
      }
    }

    const token = getToken();
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        clearToken();
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => {
    setToken(token);
    setUser(u);
  };
  const logout = () => {
    clearToken();
    setUser(false);
  };
  const refreshUser = () =>
    api.get("/auth/me").then((r) => { setUser(r.data); return r.data; }).catch(() => {});
  const setTokens = (tokens_balance) =>
    setUser((u) => (u ? { ...u, tokens_balance } : u));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser, setTokens }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
